import { Component } from "react";
import {
  Router,
  browserHistory,
  hashHistory,
  applyRouterMiddleware
} from "react-router";
import { useScroll } from "react-router-scroll";
import { hot } from "react-hot-loader";

import AppRoutes from "./app-routes.jsx";
import { history } from "./util";

import UserStore from "./stores/UserStore.js";

const scrollMiddleware = useScroll((prevRouterProps, { routes, location }) => {
  if (
    location.state &&
    location.state.ignoreScrollBehavior &&
    location.action !== "POP"
  ) {
    // Ignore ignoreScrollBehavior for a "back" action (i.e. going back always restores scroll)
    return false;
  }

  if (routes.some(route => route.ignoreScrollBehavior)) {
    return false;
  }

  if (routes.some(route => route.scrollToTop)) {
    return [0, 0];
  }

  return true;
});

class AppRoot extends Component {
  constructor(props) {
    super(props);

    // Fire intercom URL change event
    history.listen(() => {
      window.Intercom("update", {
        email: UserStore.getAccount() && UserStore.getAccount().email,
        user_id: UserStore.getAccount() && UserStore.getAccount().id,
        last_request_at: parseInt((new Date()).getTime()/1000)
      })
    });
  }

  render() {
    return (
      <Router
        routes={AppRoutes}
        history={history}
        render={applyRouterMiddleware(scrollMiddleware)}
      />
    );
  }
}

export default hot(module)(AppRoot);



// WEBPACK FOOTER //
// ./src/app/app-root.jsx